import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class FlowSheetService {

  apiUri: string;
  graphUri: string;

  getFlowSheetsListApi = "api/FlowsheetBuilder/GetFlowSheets";
  deleteFlowSheetApi = "api/FlowsheetBuilder/DeleteFlowsheet/";
  saveFlowSheetApi = "api/FlowsheetBuilder/SaveFlowsheet";
  getFlowSheetDataById = "api/FlowsheetBuilder/LoadFlowsheet";
  getDataSourcesApi = "api/FlowsheetBuilder/GetDataSources";
  getDataSourceParametersApi = "api/FlowsheetBuilder/GetDataSourceParameters";
  getLatestRunDetailsApi = "api/FlowsheetBuilder/GetLatestRunDetails";
  getFlowSheetRunsListApi = "api/FlowsheetBuilder/GetFlowsheetRunsList";
  runFlowSheetApi = "api/FlowsheetBuilder/Run";
  terminiateFlowSheetApi = "api/FlowsheetBuilder/TerminateFlowsheet"
  getFlowSheetRunDetailsApi = "api/FlowsheetBuilder/GetFlowsheetRunDetails";
  tokenApi = "api/FlowsheetBuilder/getToken";
  getBpmnApi = "assets/bpmn/initial.bpmn";
  constructor(private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.flowsheetApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }
  getToken() {
    return this.http.get(this.apiUri + this.tokenApi);
  }

  getFlowSheetsList() {
    return this.http.get(this.apiUri + this.getFlowSheetsListApi);
  }

  getFlowData(id) {
    let params = { id: id };
    return this.http.get(this.apiUri + this.getFlowSheetDataById, {
      params: params
    });
  }

  deleteFlowSheet(flowSheetId) {
    let params = { flowsheetId: flowSheetId };
    return this.http.delete(this.apiUri + this.deleteFlowSheetApi, {
      params: params
    });
  }

  loadBpmn() {
    return this.http.get(this.apiUri + this.getBpmnApi, {
      headers: { observe: 'response' }, responseType: 'text'
    })
  }

  saveFlowSheet(flowSheetData) {
    return this.http.post<any>(this.apiUri + this.saveFlowSheetApi, flowSheetData);
  }

  getDataSources() {
    return this.http.get(this.apiUri + this.getDataSourcesApi);
  }

  getDataSourceParameters(dataSourceId) {
    let params = { dataSourceId: dataSourceId };
    return this.http.get(this.apiUri + this.getDataSourceParametersApi, {
      params: params
    });
  }

  getFlowsheetRunsList(flowSheetId) {
    let params = { flowSheetId: flowSheetId };
    return this.http.get(this.apiUri + this.getFlowSheetRunsListApi, {
      params: params
    });
  }

  getFlowSheetRunDetails(flowSheetRunId) {    
    let params = { flowSheetRunId: flowSheetRunId };
    return this.http.get(this.apiUri + this.getFlowSheetRunDetailsApi, {
      params: params
    });
  }

  getLatestRunDetails(flowSheetId) {
    let params = { flowSheetId: flowSheetId };
    return this.http.get(this.apiUri + this.getLatestRunDetailsApi, {
      params: params
    });
  }

  initiateNewRun(runReqData) {
    return this.http.post<any>(this.apiUri + this.runFlowSheetApi, runReqData);
  }

  terminateFlowsheetRun(runReqData) {
    return this.http.post<any>(this.apiUri + this.terminiateFlowSheetApi, runReqData);
  }
}
